export default __webpack_public_path__ + "static/media/lato-black.fb9bf987.woff";